<template>
  <div id="item_page" v-if="loaded">

      <div id="big_bg" :data-zibi="item.pic_big" :style="'background-image:url(' + getBigPic()  + '), linear-gradient(to bottom, rgba(255, 255, 255, 0) 13%, #313030)'"></div>
      <div id="big_texts" v-if="item.is_text_show == 1">
        <h2 v-text="item.artist.name"></h2>
        <h1 v-text="item.name"></h1>
        <span class="date" v-text="item.online_date_format"></span>
      </div>

      <div id="logos">

        <div v-for="logo in item.companies" :key="logo.id" ><img :src="logo.logo_path" alt="" /></div>

      </div>

    
    <!-- <ItemWidget :item="item" /> -->
  </div>
</template>

<script>

export default {
  props: ['m_item'],
  data(){
    return {
      item: [],
      id: this.$route.params.id,
      loaded: false
    }
  },
  methods: {
    getBigPic(){
      return this.item.pic_big == undefined ? this.item.pic_cover_tumb : this.item.pic_big
    }
  },
  mounted(){

    if (this.m_item && this.m_item.length !== 0)
    {
      this.item = this.m_item;
      this.$bus.$emit('open_widget', this.item);
      this.loaded = true;
      return;
    }

    this.api({ action: 'vod/get', data: { id: this.id, tk: this.$route.query.tk } }, (data) => { 
      this.item = data.data;
      this.$bus.$emit('open_widget', this.item);
      this.loaded = true;
    });
        
  }
  
}
</script>

<style lang="scss">
#item_page{
    #big_bg { position: fixed; left: 570px; right: 0px; top: 0px; bottom: 0px; z-index: 8; background-color:#000; background-size: cover; background-position: right top;}
    #big_texts { position: absolute; right: 40px; top: 40px; z-index: 9; color: #fff; line-height: normal;
        h2 {   font-size: 93px; }
        h1 {   font-size: 48px; font-weight: normal; }
        .date {   font-size: 31px; font-weight: normal; }
    }

    #logos { display: flex; gap:20px; position: absolute; right: 30px; bottom: 30px; z-index: 9;
      div { padding: 4px; border:1px solid rgba(255,255,255,0.9); background: rgba(0,0,0,0.1); border-radius: 6px;}
      img { height: 30px; width: auto;}

    }
}
</style>